// extracted by mini-css-extract-plugin
export default {"page":"YX-z","cartModal":"ZX-z","checkout":"_X-z","placeholder":"aY-z","account":"bY-z"};